import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  apiGetAvpArcoMoveUpArco,
  apiGetAvpArcoMoveDownArco,
  apiDeleteAvpArco,
} from "../shared/manager/api_manager";
import { useEffectOnce } from "../shared/manager/use_effect_once";
import { DataGrid } from "@mui/x-data-grid";
import { findNodeLabel } from "./AvpGrafoUtil";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useLingueStore } from "../sistema/storeLingua";
import { useGraphStore } from "../new-avp/test-graph/store";
export default function AvpNodeContentArcsSection({
  // pAvp,
  pNode,
  pArchi,
  pLingua,
  pActionCallback,
}) {
  const { avp, aggiornaAvp, setSelectedNode, selectedNode } = useGraphStore(
    (state) => state
  );
  const { selectedLinguaTesto } = useLingueStore((state) => state);

  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [idArcoToDelete, setIdArcoToDelete] = useState(null);

  useEffect(() => {
    if (selectedNode !== undefined) setRows(selectedNode.archi);
  }, [avp, selectedNode]);
  // }, [pNode, avp, pArchi]);

  const columns = [
    {
      field: "testo",
      headerName: selectedLinguaTesto?.AvpNodeContentArcsColumnsText,
      flex: 2,
      sortable: false,
      headerClassName: "tableHeader",
    },
    {
      field: "idNodoEnd",
      headerName: selectedLinguaTesto?.AvpNodeContentArcsColumnsEndNode,
      flex: 2,
      sortable: false,
      headerClassName: "tableHeader",
      renderCell: (params) => {
        return findNodeLabel(params.row.idNodoEnd, avp.nodi);
      },
    },
    /*    
    { field: 'lingua', headerName: 'Lingua', flex: 2, sortable: false, headerClassName: 'tableHeader', 
      renderCell: (params) => {
        let desc = "---";
        if (pLingue!=null && pLingue.length>0) {
          for (var i=0; i<pLingue.length; i++) {
            if (pLingue[i].idLingua==params.row.idLingua) {
              desc = pLingue[i].descrizione;
              break;
            }
          }
        }
        return desc;
      }
    },
*/
    {
      field: "action",
      headerName: "",
      width: 160,
      sortable: false,
      headerClassName: "tableHeader",
      align: "right",
      renderCell: (params) => {
        const onClick = (event) => {
          event.stopPropagation(); // don't select this row after clicking

          const action = event.target.dataset.action;
          if (action == "moveup") {
            handleMoveUp(params.row.idArco);
          } else if (action == "movedown") {
            handleMoveDown(params.row.idArco);
          } else if (action == "delete") {
            handleDelete(params.row.idArco);
          } else if (action == "edit") {
            handleEdit(params.row.idArco);
          }
        };

        let showUp = params.row.ordine > 1;
        let showDown = params.row.ordine == 1;

        return (
          <div className="tableActionSmallButton">
            <img
              data-action="edit"
              src="/images/edit_btn.svg"
              onClick={onClick}
              title={selectedLinguaTesto?.AvpNodeContentArcsButtonEdit}
            />
            <img
              data-action="delete"
              src="/images/delete_btn.svg"
              onClick={onClick}
              title={selectedLinguaTesto?.AvpNodeContentArcsButtonDelete}
            />
            <img
              data-action="moveup"
              src="/images/move_up_arrow.svg"
              onClick={onClick}
              title={selectedLinguaTesto?.AvpNodeContentArcsButtonMoveUp}
            />
            <img
              data-action="movedown"
              src="/images/move_down_arrow.svg"
              onClick={onClick}
              title={selectedLinguaTesto?.AvpNodeContentArcsButtonMoveDown}
            />
          </div>
        );
      },
    },
  ];

  function handleMoveUp(idArco) {
    apiGetAvpArcoMoveUpArco(idArco, function (response) {
      //console.log(response);
      if (response != null && response.status >= 200 && response.status < 400) {
        aggiornaAvp(avp.idAvp);
        // setSelectedNode(String(selectedNode.idNodo));

        // if (pActionCallback!=null) {
        //   pActionCallback("arcMoveUp", selectedNode.idNodo, idArco);
        // }
        // else {
        //   console.warn("pActionCallback is null", pActionCallback);
        // }
      }
    });
  }
  // function handleMoveUp(idArco) {
  //   apiGetAvpArcoMoveUpArco(idArco, function(response){
  //     //console.log(response);
  //     if (response!=null && response.status>=200 && response.status<400) {
  //       if (pActionCallback!=null) {
  //         pActionCallback("arcMoveUp", selectedNode.idNodo, idArco);
  //       }
  //       else {
  //         console.warn("pActionCallback is null", pActionCallback);
  //       }

  //     }
  //   });
  // }

  function handleMoveDown(idArco) {
    apiGetAvpArcoMoveDownArco(idArco, function (response) {
      //console.log(response);
      if (response != null && response.status >= 200 && response.status < 400) {
        // if (pActionCallback!=null) {
        //   pActionCallback("arcMoveDown", selectedNode.idNodo, idArco);
        // }
        // else {
        //   console.warn("pActionCallback is null", pActionCallback);
        // }
        aggiornaAvp(avp.idAvp);

        // setSelectedNode(String(selectedNode.idNodo));
      }
    });
  }

  function handleDelete(idArco) {
    if (selectedNode !== undefined && selectedNode.nodoStart === false) {
      setIdArcoToDelete(idArco);
      setDeleteDialogOpen(true);
    } else {
      alert(selectedLinguaTesto?.AvpNodeContentArcsAlertDelete);
    }
  }

  const handleDeleteDialogClose = () => {
    setDeleteDialogOpen(false);
  };

  const handleDeleteDialogConfirm = () => {
    
    setDeleteDialogOpen(false);
    apiDeleteAvpArco(idArcoToDelete, function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        
        // if (pActionCallback!=null) {
        //   pActionCallback("arcDelete", selectedNode.idNodo, idArcoToDelete);
        // }
        // else {
        //   console.warn("pActionCallback is null", pActionCallback);
        // }
        aggiornaAvp(avp.idAvp);

        // setSelectedNode(String(selectedNode.idNodo));
      }
    });
  };

  function handleEdit(idArco) {
    let arco = null;
    if (rows != null && rows.length > 0) {
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].idArco == idArco) {
          arco = rows[i];
          break;
        }
      }
    }

    if (arco != null) {
      let idLingua = pLingua != null ? pLingua.idLingua : arco.idLingua;
      navigate(
        "/avp/grafo/nodo/arco?action=edit&idavp=" +
          avp.idAvp +
          "&idnodo=" +
          selectedNode.idNodo +
          "&idarco=" +
          idArco +
          "&idlingua=" +
          idLingua
      );
    }
  }

  function handleNew() {
    if (selectedNode != null && selectedNode.nodoStart == false) {
      let idLingua = pLingua != null ? pLingua.idLingua : "";
      navigate(
        "/avp/grafo/nodo/arco?action=edit&idavp=" +
          avp.idAvp +
          "&idnodo=" +
          selectedNode.idNodo +
          "&idlingua=" +
          idLingua
      );
    } else {
      alert("Non è consentito aggiungere ulteriori archi");
    }
  }

  if (selectedNode != null) {
    return (
      <div id="avp-gestioneavp-nodearcs-section">
        <div className="group">
          <div
            className="avp-gestioneavp-nodearcs-section-title"
            style={{ position: "relative", float: "left" }}
          >
            {selectedLinguaTesto?.AvpNodeContentArcsArcTitle}
          </div>
          <div style={{ position: "relative", float: "right" }}>
            <button style={{ height: "35px" }} onClick={handleNew}>
              {selectedLinguaTesto?.AvpNodeContentArcsButtonNew}
            </button>
          </div>
        </div>

        <div className="avp-gestioneavp-nodearcs-section-box">
          <DataGrid
            sx={{
              m: 1,
              "& .MuiDataGrid-root": {
                margin: 0,
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: 600,
              },
              "& .MuiDataGrid-cell": {
                fontSize: 13,
              },
              "& .MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
                outline: "none !important",
              },
              "& .MuiDataGrid-filler": {
                display: "none",
              },
            }}
            rowHeight={40}
            disableColumnMenu
            cellSelection={false}
            getRowId={(row) => row.idArco}
            rows={rows}
            columns={columns}
            getRowClassName={(params) => "tableRow"}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
            }}
            pageSizeOptions={[10, 20]}
            disableRowSelectionOnClick
          />
        </div>

        <Dialog
          open={deleteDialogOpen}
          onClose={handleDeleteDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Conferma eliminazione"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {selectedLinguaTesto?.AvpNodeContentArcsDialogDelete}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteDialogClose}>NO</Button>
            <Button onClick={handleDeleteDialogConfirm} autoFocus>
              {selectedLinguaTesto?.AvpNodeContentArcsDialogConfirm}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  } else {
    return <div id="avp-gestioneavp-nodearcs-section"></div>;
  }
}
